// Generated by ReScript, PLEASE EDIT WITH CARE


var stateMachine = {
  contents: "Initial"
};

function isAnythingInTransit() {
  var match = stateMachine.contents;
  if (typeof match === "object") {
    if (match.TAG === "QuestionPersisting") {
      return true;
    } else {
      return false;
    }
  }
  switch (match) {
    case "ProvisioningNewAttempt" :
    case "MarkingComplete" :
        return true;
    default:
      return false;
  }
}

export {
  stateMachine ,
  isAnythingInTransit ,
}
/* No side effect */
